import AbstractPage from 'pages/AbstractPage';

export default class DefaultPage extends AbstractPage {
    constructor() {
        super();
    }
}

$(function () { app.pageController = window.page = new DefaultPage(); });
